export default "__VITE_ASSET__DvpVZq5N__"